/* eslint-disable no-restricted-imports */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { OctopusTheme, withTheme } from "components/Theme";
import { SvgIcon } from "@material-ui/core";
import React from "react";
import cn from "classnames";
import { Item } from "primitiveComponents/form/Select/Select";
import * as PropTypes from "prop-types";
import RequestRaceConditioner from "utils/RequestRaceConditioner";
import Menu from "components/Menu/Menu";
import Events from "material-ui/utils/events";
import ReactDOM from "react-dom";
import ActionButton, { ActionButtonType } from "components/Button";
import BusyIndicator from "components/BusyIndicator";
import Popover, { Origin } from "components/Popover";
import ClearFix from "material-ui/internal/ClearFix";
import IconButton from "material-ui/IconButton";
import { ThirdPartyIcon, ThirdPartyIconType } from "primitiveComponents/dataDisplay/Icon";
import FilterSearchBox from "components/FilterSearchBox";
import { Section } from "components/Section/Section";
import { MenuItem } from "material-ui";
import { transitions } from "material-ui/styles";
import Note from "primitiveComponents/form/Note/Note";
import { noOp } from "utils/noOp";
import GitRef from "./GitRef";

const keycode = require("keycode");
const styles = require("./style.less");

const GitIcon = (props: any) =>
    withTheme((theme) => (
        <SvgIcon {...props} htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral, width: "0.7rem", height: "auto", ...props.style }} viewBox="0 0 640 1024">
            {/* eslint-disable-next-line */}
            <path d="M512 192c-71 0-128 57-128 128 0 47 26 88 64 110v18c0 64-64 128-128 128-53 0-95 11-128 29v-303c38-22 64-63 64-110 0-71-57-128-128-128s-128 57-128 128c0 47 26 88 64 110v419c-38 22-64 63-64 110 0 71 57 128 128 128s128-57 128-128c0-34-13-64-34-87 19-23 49-41 98-41 128 0 256-128 256-256v-18c38-22 64-63 64-110 0-71-57-128-128-128z m-384-64c35 0 64 29 64 64s-29 64-64 64-64-29-64-64 29-64 64-64z m0 768c-35 0-64-29-64-64s29-64 64-64 64 29 64 64-29 64-64 64z m384-512c-35 0-64-29-64-64s29-64 64-64 64 29 64 64-29 64-64 64z" />
        </SvgIcon>
    ));

function getStyles(props: GitRefDropDownProps, context: any, theme: OctopusTheme) {
    const spacing = context.muiTheme.baseTheme.spacing;
    const palette = context.muiTheme.baseTheme.palette;
    const { disabled } = props;
    return {
        control: {
            cursor: disabled ? "default" : "pointer",
            height: "100%",
            position: "relative" as const,
            width: "100%",
        },
        icon: {
            width: `1.5rem`,
            height: `1.5rem`,
            padding: 0,
            right: 0,
            top: 0,
            marginTop: 0,
            fill: theme.secondaryText,
        },
        iconChildren: {
            fill: "inherit",
        },
        gitIcon: {
            fill: disabled ? palette.disabledColor : theme.iconNeutral,
        },
        label: {
            display: "flex" as const,
            alignItems: "center" as const,
            color: disabled ? palette.disabledColor : palette.textColor,
            overflow: "hidden" as const,
            opacity: 1,
            position: "relative" as const,
            paddingRight: spacing.desktopGutter,
            textOverflow: "ellipsis" as const,
            paddingLeft: spacing.desktopGutterMini,
        },
        labelWhenOpen: {
            opacity: 0,
            top: spacing.desktopToolbarHeight / 8,
        },
        root: {
            display: "inline-block",
            fontSize: spacing.desktopDropDownMenuFontSize,
            fontFamily: context.muiTheme.baseTheme.fontFamily,
            outline: "none",
            position: "relative",
            transition: transitions.easeOut(),
        },
        rootWhenOpen: {
            opacity: 1,
        },
        buttons: {
            position: "absolute" as const,
            right: 0,
            top: "0.2rem",
        },
        dropDownMenu: {
            display: "block",
            border: `1px solid ${theme}`,
        },
        filter: {
            margin: "0 1rem",
            display: "flex",
            flexDirection: "row" as any,
            alignItems: "center",
        },
        empty: {
            margin: "0 1rem",
        },
    };
}

interface GitRefDropDownProps {
    onChange: (value: string) => void;
    items: Item[];
    totalItems: number;
    value: any;
    empty?: string;
    style?: "grey" | "white";
    disabled?: boolean;
    onFilterChanged?(value: string): Promise<Item[]>;
    onRequestRefresh(): Promise<void>;
    containerWidth?: boolean;
}

interface GitRefDropDownState {
    open: boolean;
    anchorElement: any;
    filter: string | undefined;
    filteredItems: Item[] | null;
    isBusySearching: boolean; // UX: Localised refresh indicator pattern.
    isBusyRefreshing: boolean;
}

class GitRefDropDown extends React.Component<GitRefDropDownProps, GitRefDropDownState> {
    static muiName = "DropDownMenu";
    static contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    private searchRaceConditioner = new RequestRaceConditioner();

    constructor(props: GitRefDropDownProps) {
        super(props);
        this.state = {
            open: false,
            anchorElement: null,
            filter: undefined,
            filteredItems: null,
            isBusySearching: false,
            isBusyRefreshing: false,
        };
    }

    private menu: Menu | undefined;
    rootNode = undefined as any;
    arrowNode = undefined as any;

    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */
    getInputNode() {
        const rootNode = this.rootNode;

        rootNode.focus = () => {
            this.setState({
                open: !this.state.open,
                anchorElement: this.rootNode,
            });
        };

        return rootNode;
    }

    handleTouchTapControl = (event: React.MouseEvent) => {
        event.preventDefault();
        this.setState({
            open: !this.state.open,
            anchorElement: this.rootNode,
        });
    };

    handleRequestCloseMenu = () => {
        this.close(false);
    };

    handleEscKeyDownMenu = () => {
        this.close(true);
    };

    handleKeyDown = (event: React.KeyboardEvent<{}>) => {
        switch (keycode(event)) {
            case "up":
            case "down":
            case "space":
            case "enter":
                event.preventDefault();
                this.setState({
                    open: true,
                    anchorElement: this.rootNode,
                });
                break;
        }
    };

    handleFilterKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        switch (keycode(event)) {
            case "esc":
                this.close(true);
                break;
            case "down":
                if (this.menu && React.Children.count(this.props.children) > 0) {
                    event.preventDefault();
                    this.menu.setFocusIndex(event, 0, true);
                }
                break;
        }
    };

    handleItemTouchTap = (event: any, child: any, index: number) => {
        event.persist();
        event.preventDefault();
        this.setState(
            {
                open: false,
            },
            () => {
                if (this.props.onChange) {
                    this.props.onChange(child.props.value);
                }

                this.close(Events.isKeyboard(event));
            }
        );
    };

    handleChange = (event: any, value: any) => {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    close = (isKeyboard: boolean) => {
        this.setState(
            {
                open: false,
                //filter: undefined, //UX: review - we should refactor this Popover component so all filtering can be unmounted when we close.
                //filteredItems: null,
            },
            () => {
                if (isKeyboard) {
                    const dropArrow = this.arrowNode;
                    // eslint-disable-next-line react/no-find-dom-node
                    const dropNode = ReactDOM.findDOMNode(dropArrow) as HTMLElement;
                    dropNode.focus();
                    dropArrow.setKeyboardFocus(true);
                }
            }
        );
    };

    private handleFilterChanged = async (value: string) => {
        // Reset any filteredItems we're currently viewing _before_ the search begins, otherwise you end up staring at stale items while a search is happening / feels wrong.
        this.setState({ filter: value, filteredItems: [], isBusySearching: true });
        await this.searchRaceConditioner.avoidStaleResponsesForRequest(this.getFilteredResults(value), (filteredItems) => {
            this.setState({ filteredItems, isBusySearching: false });
        });
    };

    private getFilteredResults = async (value: string) => {
        let filteredItems: Item[] = [];
        if (this.props.onFilterChanged) {
            filteredItems = await this.props.onFilterChanged(value);
        } else {
            filteredItems = this.props.items.filter((item) => {
                return item.text.toLowerCase().search(value.toLowerCase()) !== -1;
            });
        }
        return filteredItems;
    };

    private onRequestRefresh = async () => {
        await this.doBusyTaskForRefreshing(this.props.onRequestRefresh);
    };

    private renderFetch() {
        return (
            <div>
                <div className={styles.fetchButtonContainer}>
                    <ActionButton type={ActionButtonType.Secondary} label="FETCH" title="Fetch the latest branches from your configured remote repository" onClick={this.onRequestRefresh} className={styles.fetchButton} />
                </div>
                {this.state.isBusyRefreshing && <BusyIndicator show={true} />}
            </div>
        );
    }

    private renderDropDown = (theme: OctopusTheme) => {
        const anchorOrigin: Origin = {
            vertical: "bottom",
            horizontal: "left",
        };

        const { items, value, disabled } = this.props;
        const { anchorElement, open } = this.state;

        const { prepareStyles } = this.context.muiTheme;
        const inlineStyles = getStyles(this.props, this.context, theme);

        const activeItems = this.state.filteredItems ?? items;

        const style = this.props.style ?? "grey";
        const className = styles["dropDownMenu-" + style];

        let width: number | null = null;
        const autoWidth = this.props.containerWidth !== true;
        if (this.rootNode && this.props.containerWidth) {
            width = this.rootNode.offsetWidth;
        }

        return (
            <div
                ref={(node) => {
                    this.rootNode = node;
                }}
                className={cn(styles.dropDownMenu, className)}
                style={prepareStyles(Object.assign({}, inlineStyles.root, open && inlineStyles.rootWhenOpen))}
            >
                {/*This should ideally be a button html element (semantic html is much better for accessibility)
                This breaks the styling enough that I didn't want to commit to this change right now in the short time that I have.*/}
                <div role="button" onClick={disabled ? noOp : this.handleTouchTapControl} aria-label="Switch branch">
                    <ClearFix style={inlineStyles.control}>
                        <div style={inlineStyles.label} className={styles.label}>
                            <GitIcon className={styles.gitIcon} style={inlineStyles.gitIcon} />
                            <GitRef className={styles.value} value={value} />
                        </div>
                        <div style={inlineStyles.buttons} className={styles.buttonDropDown}>
                            <IconButton
                                disabled={disabled}
                                onKeyDown={disabled ? noOp : this.handleKeyDown}
                                ref={(node) => {
                                    this.arrowNode = node;
                                }}
                                style={Object.assign({}, inlineStyles.icon)}
                                iconStyle={inlineStyles.iconChildren}
                                {...{ "aria-label": "ToggleDropDown" }}
                            >
                                <ThirdPartyIcon iconType={ThirdPartyIconType.ArrowDropDown} />
                            </IconButton>
                        </div>
                    </ClearFix>
                </div>
                <Popover anchorOrigin={anchorOrigin} anchorEl={anchorElement} open={open} onClose={this.handleRequestCloseMenu} className={styles.popoverContainer}>
                    <div onKeyDown={this.handleFilterKeyDown} style={inlineStyles.filter}>
                        <FilterSearchBox placeholder={"Search for branches..."} autoFocus={true} value={this.state.filter} onChange={this.handleFilterChanged} fullWidth={true} />
                    </div>
                    {style == "grey" && (
                        <Note className={styles.helperText}>
                            Want to create a new branch?
                            <br />
                            We're still working on that in Octopus. Please create a new branch in your repository and click Fetch.
                        </Note>
                    )}
                    <Menu
                        ref={(menu: Menu) => (this.menu = menu)}
                        disableAutoFocus={true}
                        maxHeight={400}
                        desktop={true}
                        value={value}
                        onEscKeyDown={this.handleEscKeyDownMenu}
                        onItemTouchTap={this.handleItemTouchTap}
                        selectedMenuItemStyle={{ color: theme.primary }}
                        autoWidth={autoWidth}
                        width={width}
                    >
                        {this.state.isBusySearching && (
                            <Section>
                                <BusyIndicator show={this.state.isBusySearching} inline={true} />
                            </Section>
                        )}
                        {activeItems.length === 0 && this.props.empty && !this.state.isBusySearching && <span style={inlineStyles.empty}>{this.props.empty}</span>}
                        {activeItems.map((item, index) => {
                            // Needs preventDefault onMouseDown to prevent https://www.chromestatus.com/features/6662647093133312
                            return (
                                <MenuItem
                                    style={{ whiteSpace: "normal", lineHeight: "1.4", padding: "0.4rem 1rem 0.4rem 0", minHeight: "0", width: "100%" }}
                                    innerDivStyle={{ padding: "0 1rem" }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    key={item.value ?? index}
                                    value={item.value}
                                    primaryText={item.text && <GitRef value={item.text} />}
                                />
                            );
                        })}
                    </Menu>
                    {activeItems.length < this.props.totalItems && (
                        <div className={styles.warning}>
                            Displaying {activeItems.length} out of {this.props.totalItems} branches.
                        </div>
                    )}
                    {this.renderFetch()}
                </Popover>
            </div>
        );
    };

    private doBusyTaskForRefreshing = async (action: () => Promise<void>): Promise<void> => {
        this.setState({ isBusyRefreshing: true });
        try {
            await action();
        } finally {
            this.setState({ isBusyRefreshing: false });
        }
    };

    render() {
        return withTheme((theme) => {
            return this.renderDropDown(theme);
        });
    }
}

export default GitRefDropDown;
